const PRINT_CHARTS = new Set(["dates", "labelCount"]);
const VERIFY_CHARTS = new Set(["verifyDates", "verifyCount"]);

const PHASE_MESSAGES = {
  fetching: {
    print: "Загрузка данных о печати из БД...",
    verify: "Загрузка данных о сериализации из БД...",
  },
  processing: "Формирование графика...",
  queued: "Ожидание обработки...",
};

export const getChartLoadingMessage = (chartId, phase) => {
  if (phase === "processing") {
    return PHASE_MESSAGES.processing;
  }

  if (phase === "queued") {
    return PHASE_MESSAGES.queued;
  }

  if (phase === "fetching") {
    if (PRINT_CHARTS.has(chartId)) {
      return PHASE_MESSAGES.fetching.print;
    }
    if (VERIFY_CHARTS.has(chartId)) {
      return PHASE_MESSAGES.fetching.verify;
    }
  }

  return "Загрузка данных...";
};
